import { render, staticRenderFns } from "./kia-flat-rate-search-view.vue?vue&type=template&id=8e138aae&scoped=true&"
import script from "./kia-flat-rate-search-view.vue?vue&type=script&lang=js&"
export * from "./kia-flat-rate-search-view.vue?vue&type=script&lang=js&"
import style0 from "./kia-flat-rate-search-view.vue?vue&type=style&index=0&id=8e138aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e138aae",
  null
  
)

export default component.exports